import React from 'react';
import { useSelector } from 'react-redux';
import { PieChart, Pie, Cell } from 'recharts';

import useStyles from './styles';

const COLORS = [
  '#4caf50',
  '#2196f3',
  '#ff9800',
  '#009688',
  '#f44336',
  '#9e9e9e',
];

function SalesBySeller() {
  const classes = useStyles();
  const amount = 5;

  const { sellers } = useSelector(state => state.data);
  const others = sellers.find(item => item.id === 0);
  const list = sellers.filter(item => item.id !== 0);
  const tempData = list.sort((a, b) => b.value - a.value).slice(0, amount);

  if (others) {
    tempData.push({
      ...others,
      value: list
        .sort((a, b) => b.value - a.value)
        .slice(amount, list.length)
        .reduce((acc, item) => acc + item.value, others.value),
    });
  }

  const data = tempData.map((item, index) => ({
    ...item,
    formatedValue: item.value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }),
    color: COLORS[index],
  }));

  const total = data
    .reduce((acc, item) => acc + item.value, 0)
    .toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

  return (
    sellers.length > 0 && (
      <div className={classes.root}>
        <span className={classes.title}>vendedores</span>

        <PieChart width={360} height={360}>
          <Pie data={data} fill="#8884d8" legendType="line">
            {data.map((item, index) => (
              <Cell key={JSON.stringify(item)} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>

        <ul className={classes.list}>
          {data.map(item => (
            <li
              key={item.id}
              className={classes.item}
              style={{
                color: item.color,
              }}
            >
              <span>{item.name}</span>
              <span>{item.formatedValue}</span>
            </li>
          ))}
        </ul>

        <div className={classes.total}>
          <span>total</span>
          <span>{total}</span>
        </div>
      </div>
    )
  );
}

export { SalesBySeller };
